import React from 'react';

const QuestionTutorial = () => {
  return (
    <div style={{
      backgroundColor: 'white',
      boxShadow: 'var(--standard-box-shadow)',
      padding: '30px',
      margin: '20px',
      borderRadius: '2px',
      fontFamily: 'var(--font-secondary)',
    }}>
     
          <h3 style={{ color: 'var(--color2)' }}>The basics</h3>

          There are three different types of questions. Single choice questions present students with several options, and require them to choose exactly one. Multiple choice questions present students with several options, and require them to choose at least one. Essay questions require students to write a response to the question. (You can, if you like, place word limits on the essays.)
          <br /><br />
          In addition, you can include contradiction notifications, which tell students when their answers to the questions are jointly inconsistent. These don't request a response from the student, but they are like questions in that you can write the logic which controls when they appear. 

          <h3 style={{ color: 'var(--color2)' }}> Question logic</h3>

          Every question is attached to a day of the course. If you add no logic to the question, it will appear for all students when that day of the course is reached. (For options here see Schedule / Course Progress.)
          <br /><br />
          If you want to make a question's appearance conditional on a student's previous answers, you can add logic to the question using the button at the bottom of the question. In the box that appears, you can write a sentence of a language that I explain below, and the question will show iff the sentence is true. 
          <br /><br />
          Every question is associated with a randomly generated ID, which you can see in the top right corner of the question box. For a multiple choice question with id 'abc', the sentence
          <br /><br />
          <div style={{ marginLeft: '40px', fontFamily: 'monospace', fontSize: '16px', color: 'var(--color1)' }}>
            (abc, 2)
          </div>
          <br />
          is true iff the student has selected the second of that question's answers. To avoid having to type out these sentences, you can just click the blue box next to a multiple choice option, and that will copy the code for that option into the clipboard, so that you can just paste that in the logic box. 
          <br /><br />
          Sometimes you may want a question to show if some other question has been answered, no matter what the answer given was. In that case you can write
          <br /><br />
          <div style={{ marginLeft: '40px', fontFamily: 'monospace', fontSize: '16px', color: 'var(--color1)' }}>
            (abc, X)
          </div>
          <br />
          which is true iff the question with ID 'abc' has been answered. This works on essay questions as well as multiple choice questions. 
          <br /><br />
          You can also make more complex sentences using the logical operators &, ¬, and ∨ (you can also just write 'and', 'or', and 'not' which will be converted to the right symbol.) Parentheses work in the way you would expect them to. 
          
          <h3 style={{ color: 'var(--color2)' }}> Theses </h3>

       
          If the logic for showing and hiding questions becomes complex, it can be useful to define 'theses,' which are in effect abbreviations for combinations of possible student answers. For example, suppose that your course considers four arguments for the existence of God. You may want to address questions to all students who think that at least one of these arguments is sound (or students who think that none of them are). Rather than always copying in a four part disjunction, you can define a thesis - 'soundArgumentForTheism' - using this disjunction. Then you can use this thesis name in the logic for questions later in the course. If 'soundArgumentForTheism' is a thesis name, then
          <br /><br />
          <div style={{ marginLeft: '40px', fontFamily: 'monospace', fontSize: '16px', color: 'var(--color1)' }}>
            (soundArgumentForTheism)
          </div>
          <br />
          is a sentence which is true iff the sentence you gave in the logic for the thesis is true. Like any other sentence, it can be negated, combined with other conditions, etc. You can add theses using the 'Theses' button on the left sidebar.
          <br /><br />
          This is totally optional, and probably not worth it unless the logic of your site is at least moderately complex.
          <br /><br />
          Each thesis should include a name for the thesis (which is what you will use in the logic for later questions), a brief description of what position the thesis is meant to abbreviate, and the logic that defines the thesis.
          


          
        


    </div>
  );
};

export default QuestionTutorial;
